<template>
  <header class="row no-wrap justify-between q-px-md text-white">
    <div class="tlqn-member-header-menu row items-center">
      <HamburgerBtn
        :style="{ color: '#fff' }"
        class="q-mr-md"
        v-model="showQuestionnaireContents"
        :disable="$route.name !== 'member-questionnaire'"
      />
      <span class="text-bold" style="font-size: 1rem">
        浙江省小微企业调查2021
      </span>
    </div>

    <div class="tlqn-member-header-btn-group row items-center">
      <div
        class="tlqn-member-header-questionnaire-btn-group row items-center"
        v-if="isQuestionnaire"
      >
        <div class="member-header-menu-btn" @click="togglePreSubmit">
          <q-icon name="fas fa-check-circle" />
        </div>
      </div>
      <UserPre class="q-ml-sm" size="30px" />
    </div>
  </header>
</template>

<script>
import QuestionnaireMixin from "../Questionnaire/questionnaire.mixin";
export default {
  mixins: [QuestionnaireMixin],
  components: {
    HamburgerBtn: () => import("@/components/HamburgerBtn"),
    UserPre: () => import("@/components/user/UserPre"),
  },
  computed: {
    isQuestionnaire() {
      const { $route } = this;
      return this.$route.name === "member-questionnaire";
    },
  },

  methods: {
    togglePreSubmit() {
      this.showPreSubmit = !this.showPreSubmit;
    },
  },
};
</script>

<style lang="scss">
.member-header-menu-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 5px;
  &:hover {
    background-color: rgba(#fff, 0.2);
  }
}
</style>
